"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionStatusModal = void 0;
var tslib_1 = require("tslib");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var collection_status_modal_ctrl_1 = require("./collection.status.modal.ctrl");
var collection_status_modal_style_1 = require("./collection.status.modal.style");
var status_selector_1 = require("./status.selector");
(0, theme_1.addStyles)(collection_status_modal_style_1.Style);
var CollectionStatusModal = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionStatusModal, _super);
    function CollectionStatusModal(ctx, collections) {
        var _this = _super.call(this, ctx) || this;
        _this.ctrl = new collection_status_modal_ctrl_1.CollectionStatusModalCtrl(collections);
        _this.statusSelector = new status_selector_1.StatusSelector();
        _this.addState(_this.statusSelector.inputState);
        return _this;
    }
    Object.defineProperty(CollectionStatusModal.prototype, "nodes", {
        get: function () {
            return (0, mithril_1.m)('div', { className: collection_status_modal_style_1.CSS.container }, [
                (0, mithril_1.m)('div', { className: collection_status_modal_style_1.CSS.content }, [
                    (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_STATUS_CONFIRM, { count: this.ctrl.collections.length })),
                    this.statusSelector.view()
                ]),
                (0, mithril_1.m)('div', { className: collection_status_modal_style_1.CSS.contentSecond }, [
                    this.viewStats(),
                    this.statusSelector.selectedStats()
                ])
            ]);
        },
        enumerable: false,
        configurable: true
    });
    CollectionStatusModal.prototype.viewStats = function () {
        var actualStatuses = this.ctrl.getActualStatuses();
        return (0, mithril_1.m)('ul', { className: collection_status_modal_style_1.CSS.list }, Object.keys(actualStatuses).map(function (key) {
            var statusText = (key === 'undefined') ? 'No status' : key;
            return (0, mithril_1.m)('li', statusText + ': ' + actualStatuses[key]);
        }));
    };
    CollectionStatusModal.prototype.submit = function () {
        return this.ctrl.SetStatusCollections(this.statusSelector.selectedStatus, this.statusSelector.ctrl.allStatuses);
    };
    return CollectionStatusModal;
}(modal_form_component_1.ModalFormComponent));
exports.CollectionStatusModal = CollectionStatusModal;
//# sourceMappingURL=collection.status.modal.js.map